// 무통장입금 계좌 설정 섹션 URL (2026-08-06 KST 추가)
const bankTransferSettingsSection = "/bank-transfer-settings";

export const bankTransferSettingsPath = bankTransferSettingsSection;
